// all application settings
var Settings = {
    parseAppId: 'devapp',
    parseKey: '',
    //parseUrl: 'http://localhost:1337/parse',
    parseUrl: 'https://devappshogun.herokuapp.com/parse',
    deepLinkUrl: '',
	supportClientId: 'bLJuqeyC6u',
    login: false,
    permissions: {
      "userViewer":"",
      "reportViewer":"reports",
      "categoryViewer":"reports",
      "personalViewer":"",
      "profileViewer":"",
      "useraddViewer":"addusers",
      "profilesViewer":"profiles",
      "usersViewer":"consultusers",
      "sendpushnotificationsViewer":"news",
      "admincategoriesViewer":"admincategories",
      "chartsViewer":"reportcharts",
      "tragraphsViewer":"usercharts",
      'newsViewer':"news",
    },
	allowreubicarreports : true,
	pushNotifPublicKey: 'BFr_2K_VJrmp0xJ54cpopUK1Pav8bYjJMd8UkEH3gN0icCUfJ-P9dRVl1WJSJNY1cixCb6T7s6PFK5TzZYbOCpA',
	req2fa: false,
};

window.arrlang = {
	"en": {
		"OptMenu1" : "Reports",
		"OptMenu2" : "Saved Reports",
		"OptMenu3" : "Users",
		"SubmenuOpt1" : "Add User",
		"SubmenuOpt2" : "Consult User",
		"SubmenuOpt3" : "Profiles",
		"FooterMenuOpt1" : "Home",
		"FooterMenuOpt2" : "Profile",
		"FooterMenuOpt3" : "Log Out",
	},
	'es' : {
		"FirstLoginTittle" : "Cambio de contraseña",
		"FirstLoginSubTittle" : "Cambio de contraseña",
		"FirstPasswordField" : "Nueva Contraseña",
		"FirstPasswordFieldHover" : "Dig&iacute;te su Nueva Contrase&ntilde;a",
		"FirstConfirmPasswordField" : "Confirmar Contraseña",
		"FirstConfirmPasswordFieldHover" : "Confirme su Contrase&ntilde;a",
		"ChangePswBtn" : "Cambiar contraseña",
		"InputAPassword" : "Digite una contraseña",
		"InputAToken" : "Digite un token de autenticación a 2 pasos",
		"SamePassword" : "Confirmar contraseña es diferente a la contraseña",
		"ValidPassword" : "La contraseña debe ser igual o mayor a 8 caracteres, igual o menor a 24 caracteres y tener al menos una minúscula, una mayúscula y un número.",
		"FirstLoginPswdChangeSuccess": "Contraseña cambiada exitosamente",
		"ActivateTokenSuccess": "Autenticacion a 2 pasos habilitada",
		"FirstLoginTimeout": "Tiempo de espera para cambiar la contraseña agotado. Cambie la contraseña dentro de los 60 minutos estipulados.",
		"Req2FATimeout": "Tiempo de espera para activar la autenticación a 2 pasos agotado. Active la autenticación a 2 pasos dentro de los 60 minutos estipulados.",
		"OptMenuChangelog": "Versiones",
		"ListVersionsTittle": "Versiones",
		"ListUsersTittle" : "Lista de Usuarios",
		"DeleteUser" : "Eliminar Usuario",
		"UserDeleted" : "Usuario Eliminado",
		"UserNotDeleted" : "Usuario no Eliminado",
		"DeleteNews" : "Eliminar Noticia",
		"NewsNotDeleted" : "Noticia no Eliminada",
		"NewsAttachedLink" : "Ver enlace adjunto",
		"ShowMoreNews" : "Ver más",
		"NewsPreview" : "Previsualización noticia",
		"EditNewsbtn" : "Editar Noticia",
		"EditNewsPreview" : "Editar noticia",
		"SaveNewsbtn" : "Guardar Noticia",
		"SaveEditNewsbtn" : "¿Realmente desea cambiar esta noticia?",
		"Charttittle" : "Gráfico General",
		"YearsRange" : "Rango de Años",
		"QuantReports" : "Cantidad de Reportes",
		"ToastrAccept" : "Aceptar",
		"ToastrCancel" : "Cancelar",
		"Sunday" : "Domingo",//sin traducir
		"Monday" : "Lunes",//sin traducir
		"Tuesday" : "Martes",//sin traducir
		"Wednesday" : "Miércoles",//sin traducir
		"Thursday" : "Jueves",//sin traducir
		"Friday" : "Viernes",//sin traducir
		"Saturday" : "Sábado",//sin traduci
		"Januarylong" : "Enero",//sin traducir
		"Februarylong" : "Febrero",//sin traducir
		"Marchlong" : "Marzo",//sin traducir
		"Aprillong" : "Abril",//sin traducir
		"Maylong"  : "Mayo",//sin traducir
		"Junelong" : "Junio",//sin traducir
		"Julylong" : "Julio",//sin traducir
		"Augustlong" : "Agosto",//sin traducir
		"Septemberlong" : "Septiembre",//sin traducir
		"Octoberlong"  : "Octubre",//sin traducir
		"Novemberlong" : "Noviembre",//sin traducir
		"Decemberlong" : "Diciembre",
		"Monthrange" : "Rango de meses:",
		"January" : "Ene",//monthsof the year //sin traducir
		"February" : "Feb",//sin traducir
		"March" : "Mar",//sin traducir
		"April" : "Abr",//sin traducir
		"May" : "May",//sin traducir
		"June" : "Jun",//sin traducir
		"July" : "Jul",//sin traducir
		"August" : "Ago",//sin traducir
		"September" : "Sep",//sin traducir
		"October" : "Oct",//sin traducir
		"November" : "Nov",//sin traducir
		"December" : "Dic",//sin traducir
		"daysx" : ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
		//admin categories
		"EnterAdminCategUser" : 'Elegir Usuario',////sin traducir
		"SaveCateAdminBtn" : "Guardar",////sin traducir
		"NoAdminforCateg" : "Sin Definir",////sin traducir
		"ActivateCategory" : "Activar Categoría",//sin traducir
		"Activatescategorymessage" : "Categoria Activada",//sin traducir
		"ActivateSubCategory" : "Activar Subcategoría",//sin traducir
		"Deactivatecategory" : "Desactivar Categoría",//sin traducir
		"CategoryDeactivated" : "Categoría Desactivada",//sin traducir
		"CategorynoDeactivated" : "Categoría no Desactivada",//sin traducir
		"DeactivateSubcategory" : "Desactivar Subcategoría",//sin traducir
		"SubcategoryDeactivated" : "Subcategoría Desactivada",//sin traducir
		"SubCategorynoDeactivated" : "Subcategoría no Desactivada",//sin traducir
		"Errorpushnot" : "Por favor Llenar Los Dos Campos para Enviar Notificaciones.",//sin traducir
		"confirmsendpushnot" : "Por favor confirmar el envío de la notificación a todos los usuarios.",//sin traducir
		"confirmsendpushnotmessage" : "Se envío la notificación correctamente.",//sin traducir
		"Errortroubleshooting" : "Por favor Llenar Los Dos Campos para Crear Ticket de Soporte.",//sin traducir
	   "confirmsendtroubleshooting" : "Ticket de Soporte creado satisfactoriamente.",//sin traducir
		"selnewreport" : "Nuevos",
		"selasginreport" : "Asignados",
		"selarchivereport" : "Archivados",
		"Asign" : "Categorías de reportes Asignados",
		"New" : "Categorías de reportes Nuevos",
		"Archive" : "Categorías de reportes Archivados",
		"asigntittle2" : "Mostrando reportes Asignados",
		"newtittle2" : "Mostrando reportes Nuevos",
		"archivetittle2" : "Mostrando reportes Archivados",
		"NoFilestodiscard" : "No hay archivos para Descartar",
		"NoFilestosave": "No hay archivos para guardar",
		"Filetstosave":"Guardar Archivos",
		"Filetsnotsave":"Archivos no Guardados",
		"filesnotest":"Archivos de la nota: ",
		"AsignedReportMessage": "Reporte asignado correctamente",
		"PriorityReportMessage": "Reporte priorizado correctamente",
		"NoteFilestext" : "Archivos Adjuntos",
		"NoFilestoshow" : "No hay archivos que mostrar.",
		"LoadReport" : "Cargando reporte ",
		"messagetochangestatus": "Por favor indicar el motivo de cerrar el reporte:",
		"messagetochangestatus2": "Por favor indicar el motivo de descarte el reporte:",
		"SaveStateok": "Estado guardado correctamente",
		"messagetochangestatus3": "Por favor indicar el motivo del cambio de estado del reporte",
		"tableheaderrecive" : "Reportes Totales",
		"tableheadernew" : "Reportes Nuevos",
		"tableheaderclosed " :"Reportes Cerrados",
		"tableheaderdiscard" : "Reportes Descartados",
		"tableheaderassigned" : "Reportes Asignados",
		"generaltable": "General",
		"allcategories": "Todas las categorías",
		"ShogunInform" : "Informe Shogun Monitor:",
		"Inform" : "Informe: ",
		"Numberreport" : "Número de Denuncia",
		"tabledate" : "Fecha y Hora de Creación",
		"tablecategory" : "Categoría",
		"tablesubcategory" : "Subcategoría",
		"tableuser" : "Usuario",
		"tabledatefirstresponse" : "Fecha y Hora de Primera Respuesta",
		"tablestate": "Estado de Denuncia",
		"tablereason" : "Motivo de Cierre o Descarte",
		"tabledateclosediscard": "Fecha y Hora de Cierre o Descarte",
		"tableasign" : "Asignado",
		"tablepriority" :"Prioridad",
		"tabledescription" : "Descripción",
		"tablecomments" : "Comentarios",
		"Anonreport" : "Anónimo",
		"open" : "Abierto",
		"close" : "Cerrado",
		"discard" : "Descartado",
		"exporttable" : "Exportar Tabla",
		"exportreports" : "Exportar Reportes",
		"nopriority" : "Prioridad: Sin asignar",
		"lowpriority" : "Prioridad: Baja",
		"midpriority" : "Prioridad: Media",
		"highpriority" : "Prioridad: Alta",
		"warning" : "Advertencia",
		"warningmessage" : "No tiene los permisos para ver este reporte.",
		"notifToday": "Hoy",
		"RemoveUser" : "¿Realmente desea eliminar este usuario?",
		"ChangeUserEmail" : "¿Realmente desea cambiar el correo de este usuario?",
		"ChangeUserUsername" : "¿Realmente desea cambiar el nombre de este usuario?",
		"ChangeUserRole" : "¿Realmente desea cambiar el role de este usuario?",
		"ChangeUserPswd" : "¿Realmente desea cambiar la contraseña de este usuario?",
		"DeleteLanguage": "Borrar lenguaje. Continuar?",
		"UserLimitExceeded": "Máximo de usuarios alcanzado.",
		"RemAllCollaboratorsReport": "¿Realmente desea remover todos los colaboradores de este reporte?",
		"RemAllCollaboratorsSuperCat": "¿Realmente desea remover todos los colaboradores de esta categoría?",
		"InternetConnectionError": "Problema de conexión con el servidor",
		"RecoverPasswordErrorMsg": "Ocurrió un error, intente más tarde.",
		"RecoverPasswordOkMsg": "Consulte su correo electrónico para restablecer su contraseña.",
		"LoginError": "Usuario o contraseña inválidos. Por favor intente de nuevo.",
		"ChatSendMessageError": "Error al ingresar comentario.",
		"SuperCategoryUpdateError": "Error al ingresar la categoría.",
		"NewSubCategoryError": "Error al ingresar la Subcategoría.",
		"NewSuperCategoryError": "Error al ingresar la categoría.",
		"DelUserInChargeReportError": "Reporte no asignado, hubo un problema con la red.",
		"NewRoleError": "Error al crear rol",
		"NewReportCommentError": "Error al ingresar comentario.",
		"NewLanguageError": "Error al agregar lenguaje.",
		"EditLanguageError": "Error al agregar lenguaje.",
		"DelLanguageError": "Error al agregar lenguaje.",
		"DeletedUser": "Usuario borrado",
		"DeleteRoleBtn": "Eliminar",
		"UserAssignedToRole": "Hay un usuario asociado al perfil",
		"DeleteRole": "¿Realmente desea eliminar este perfil?",
		"ChangeRole": "¿Realmente desea cambiar el nombre de este perfil?",
		"ValidRoleName" : "El nombre del perfil sólo puede tener caracteres alfanuméricos, _, - y espacios en blanco",
		"RoleNameNotSaved": "Error al cambiar el nombre de este perfil",
		"SameNameRole": "Existe otro perfil con el mismo nombre",
		"Adminnotitle": "Bitácora de denuncia",
		"RoleCreated": "Operación realizada",
		"RoleNotSaved": "Perfil no guardado correctamente, intenté de nuevo",
		"AdminNoteSeeMore": "Ver más",
		"tableadminnotes": "Bitácora de denuncia",
		"troubleContactSupport": "En caso de tener problemas con su inicio de sesión o perdida del token, por favor contactar al correo soporte@shogunmonitor.com",
		"ListSupportTicketsTittle": "Lista de Tickets de Soporte",
		"OptMenu7": "Soporte",
		"OptMenuSupport1": "Guías",
		"OptMenuSupport2": "Mis Tickets",
		"SupportTicketTittle": "Detalle del ticket #",
		"SupportTicketDate": "Fecha del ticket:",
		"SupportTicketDescriptionTittle": "Información del ticket",
		"SearchReportsError": "Error en la búsqueda de reportes",
		"ChnagePasswordError": "Error al cambiar la contraseña",
		"ActivateTokenError": "Error al activar la autenticación a 2 pasos",
		"tableheaderstatus": "Estado",
		"ChangeSubCatSucess": "Categoría cambiada satisfactoriamente",
		"ReportRelocateBtn": "Reubicar",
		"UserDesactivatedLoginError": "No puede iniciar sesión por que su usuario ha sido desactivado",
		"ActivateUserButton": "Activar Usuario",
		"DeactivateUserButton": "Desactivar Usuario",
		"ActivateUserQ": "¿Realmente desea activar este usuario?",
		"ActivateUserA": "Usuario activado correctamente",
		"DeactivateUserQ": "¿Realmente desea desactivar este usuario?",
		"DeactivateUserA": "Usuario desactivado correctamente",
		"AnalyticsPersonalizedFormsInfo": "Si desea tener detalle de los datos de los formularios personalizados de alguna categoría o subcategoria especifica, por favor filtre el gráfico con la categoría o subcategoría deseada.",
		"Discard": "Categorías de Reportes Descartados",
		"Close": "Categorías de Reportes Cerrados",
		"SubCatBadgeNoResponse": "Alerta de vencimiento de denuncia",
		"ReportBadgeNoResponse": "Alerta de vencimiento de denuncia",
		"SuperCatBadgeNoResponse": "Hay alertas de vencimiento de denuncia",
		"DeletedReportDataError": "Por buenas practicas de protección de datos de los usuarios, los datos del reporte han sido eliminados.",
		"SupportTicketComentsTittle": "Conversación con Soporte:",
		"TicketTittle": "Crear Ticket de Soporte",
		"TicketTittle2": "Ayuda",
		"troubleshootingTitle": "Título del problema",
		"troubleshootingContent": "Explique el problema",
		"TroubleFiles": "Adjuntar Archivos",
		"SendTroublebtn": "Enviar",
		"SendTicketError": "Error al enviar el ticket"
    }
};

export default Settings;
